import React from "react";
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import moment from 'moment-timezone';

import { PageHeader } from "../../components/PageHeader";
import { actions, GET_LOGIN_HISTORY_RESULT, GET_SESSION_RESULT } from "./redux/actions";
import Table, { Column } from '../../containers/Table/TableWithPagination';
import Strings from "../../Strings";
import { DATE_FORMAT_LLLL } from "../../constants";

// order here is important, since chromium based browsers fakes Safari
// Edge fakes Chrome, Chrome fakes Safari
// Firefox is the only one that does not fake
function getBrowserFromUserAgent(ua) {
  if (!ua) return 'Unknown';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Safari')) return 'Safari';
  return 'Other';
}

function getOSFromUserAgent(ua) {
  if (!ua) return 'Unknown';
  if (ua.includes('Windows')) return 'Windows';
  if (ua.includes('Macintosh')) return 'MacOS';
  if (ua.includes('Linux')) return 'Linux';
  return 'Other';
}

function Session(props) {
  const [sessions, setSessions] = React.useState([]);
  const [isSessionsLoading, setSessionsLoading] = React.useState(true);
  const [loginHistory, setLoginHistory] = React.useState([]);
  const [isLoginHistoryLoading, setLoginHistoryLoading] = React.useState(true);

  const { getSessions, getLoginHistory } = props;

  React.useEffect(() => {
    // Fetch sessions when component mounts
    getSessions().then(response => {
      if (response.type === GET_SESSION_RESULT) {
        setSessions(response.response.sessions);
      }
    });
    setSessionsLoading(false);
  }, []);

  React.useEffect(() => {
    // Fetch login history when component mounts
    getLoginHistory().then(response => {
      if (response.type === GET_LOGIN_HISTORY_RESULT) {
        setLoginHistory(response.response.login_record);
      }
    });
    setLoginHistoryLoading(false);
  }, []);

  return (
    <div>
      {sessions.length > 1 && (
        <>
          <PageHeader left={Strings.activeSessions} />
          <Table name="sessions" data={sessions} isLoading={isSessionsLoading}>
            <Column title={Strings.signedInOn} key="signed_in_on" value={e => moment(e.created).format(DATE_FORMAT_LLLL)} />
            <Column title={Strings.device} key="device" value={e => `${getOSFromUserAgent(e.user_agent)} - ${getBrowserFromUserAgent(e.user_agent)}`} />
            <Column title={Strings.ip} key="ip" value={e => e.ip_address} />
          </Table>
        </>
      )}
      <PageHeader left={Strings.authenticationLog} />
      <Table name="loginHistory" data={loginHistory} isLoading={isLoginHistoryLoading}>
        <Column title={Strings.timestamp} key="timestamp" value={e => moment(e.timestamp).format(DATE_FORMAT_LLLL)} />
        <Column title={Strings.device} key="device" value={e => `${getOSFromUserAgent(e.user_agent)} - ${getBrowserFromUserAgent(e.user_agent)}`} />
        <Column title={Strings.ip} key="ip" value={e => e.ip_address} />
        <Column
          title={Strings.status}
          key="status"
          value={(e, i) => i === '0' ? "Current" : (e.successful ? "Success" : "Failure")}
        />
      </Table>
    </div>
  );
}

Session.propTypes = {
  getSessions: PropTypes.func.isRequired,
  getLoginHistory: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  getSessions: () => 
    dispatch(actions.getSessions()),
  getLoginHistory: () =>
    dispatch(actions.getLoginHistory()),
});


export default connect(null, mapDispatchToProps)(Session);
